export const createMultiLevelFetchId = (fetchId) => (subFetchId) =>
  `${fetchId}.${subFetchId}`

export const createGetMultiLevelFetch = (fetchId) => (state, subFetchId) =>
  state.fetch[createMultiLevelFetchId(fetchId)(subFetchId)]
